// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"31359fee","453":"06b7c348"}[chunkId] + ".chunk.js";
};